export default __webpack_public_path__ + "img/text-box-large.796472f0.svg";